<!-- =========================================================================================
    File Name: ForgotPassword.vue
    Description: FOrgot Password Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div class="h-screen flex w-full bg-img">
        <div class="vx-col w-4/5 sm:w-4/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center">
            <vx-card>
              <ValidationObserver ref="form" v-slot="{ handleSubmit }">
                <form @submit.prevent="handleSubmit(onClickPasswordReset)" autocomplete="off">
                  <div slot="no-body" class="full-page-bg-color">
                    <div class="vx-row">
                      <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center text-center">
                        <span class="mx-auto text-big text-white">M-Hub</span>
<!--                        <img src="@/assets/images/logo/its_logo_horizontal.png" alt="ITS Logo" class="mx-auto" width="250">-->
                      </div>
                      <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg">
                        <div class="p-8" v-if="!isSubmit">
                          <div class="vx-card__title mb-8">
                            <h4 class="mb-4">Recover your password</h4>
                            <p>Please enter your email address and we'll send you instructions on how to reset your password.</p>
                          </div>
                          <ValidationProvider vid="email" name="email" rules="email|required" v-slot="{ errors }">
                            <vs-input name="email" label-placeholder="Email" v-model="email" class="w-full mb-8" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                          </ValidationProvider>
                          <vs-button type="border" to="/pages/login" class="px-4 w-full md:w-auto">Back To Login</vs-button>
                          <vs-button button="submit" class="float-right px-4 w-full md:w-auto mt-3 mb-8 md:mt-0 md:mb-0" >Recover Password</vs-button>
                        </div>
                        <div class="p-8" v-if="isSubmit">
                          <div class="vx-card__title mb-8">
                            <h4 class="mb-4">Recover your password</h4>
                            <p>
                              Thank You! <br> <br>
                              If an account matches that email address, you should receive an email with instructions on how to reset your password shortly.
                              <br>
                              If you haven't received an email in the next couple of hours please check your spam folder.
                            </p>
                          </div>

                          <!--                            <vs-input type="email" label-placeholder="Email" v-model="email" class="w-full mb-8" />-->
                          <!--                            <vs-button type="border" to="/pages/login" class="px-4 w-full md:w-auto">Back To Login</vs-button>-->
                          <!--                            <vs-button class="float-right px-4 w-full md:w-auto mt-3 mb-8 md:mt-0 md:mb-0" @click="onClickPasswordReset">Login</vs-button>-->
                          <vs-button type="border" to="/pages/login" class="px-4 mb-8 w-full md:w-auto float-right">Login</vs-button>

                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </ValidationObserver>

            </vx-card>
        </div>
    </div>
</template>

<script>
  import {RepositoryFactory} from '@/repository/RepositoryFactory';
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  const StaffRepository = RepositoryFactory.get('staff');

export default {
  data () {
    return {
      email: '',
      isSubmit: false
    }
  },
  mixins: [SuccessMessage, ErrorMessages],
  methods: {
    async onClickPasswordReset() {
      this.$vs.loading()
      try {
        const {data} =  (await StaffRepository.forgotPassword({email: this.email})).data
        this.showSuccessMessage('Password Reset Link sent successfully')
        this.isSubmit =  true
      } catch (err) {
        this.convertAndNotifyError(err)
      }
      this.$vs.loading.close()
    }
  }
}
</script>
